/* eslint-disable */

/* CONSTANTS */

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
// const handleCatchedErrors = err => {
//   throw Error(err);
// };

export const getMatchingTypes = () => async (dispatch) => {
  dispatch({ type: 'GET_MATCHING_TYPES_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/matchingtypes/", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async matchingtypes => {
      getMatchingTypesSuccess(matchingtypes, dispatch);
      return matchingtypes
    })
    .catch(error => {
      console.error(error);
      getMatchingTypesFail(error, dispatch);
    });
}

export const getMatchingTypesSuccess = (matchingTypes, dispatch) => {
  dispatch({ type: 'GET_MATCHING_TYPES_SUCCESS', payload: matchingTypes });
};

export const getMatchingTypesFail = (error, dispatch) => {
  dispatch({ type: 'GET_MATCHING_TYPES_FAIL' });
};



// WEBPACK FOOTER //
// ./src/actions/MatchingTypeActions.js